<script>
  import PSPDFKitComponent from "./PSPDFKit.svelte";
  import "carbon-components-svelte/css/white.css";
  import { Button } from "sveltestrap";
  import PSPDFKit from "pspdfkit";

  let psPDFKit;
  let arrayBuffers;
  let readOnly = false;
  let errorMsg = "";
  let subDividing = false;
  const baseUrl = `${window.location.protocol}//${window.location.host}/build/`;
  console.log(baseUrl);
  const fetcher = (fontFileName) =>
    fetch(`${baseUrl}fonts/${fontFileName}`).then((r) => {
      if (r.status === 200) {
        return r.blob();
      } else {
        throw new Error();
      }
    });

  const customFonts = [
    "mt.ttf",
    "NanumGothic.ttf",
    "NanumGothicBold.ttf",
    "NanumGothicExtraBold.ttf",
    "Roboto-Black.ttf",
    "Roboto-BlackItalic.ttf",
    "Roboto-Bold.ttf",
    "Roboto-BoldItalic.ttf",
    "Roboto-Italic.ttf",
    "Roboto-Light.ttf",
    "Roboto-LightItalic.ttf",
    "Roboto-Medium.ttf",
    "Roboto-MediumItalic.ttf",
    "Roboto-Regular.ttf",
    "Roboto-Thin.ttf",
    "Roboto-ThinItalic.ttf",
    "Meddon.ttf",
    "NunitoSans-SemiBold.ttf",
    "notosanskr.otf",
  ].map((font) => new PSPDFKit.Font({ name: font, callback: fetcher }));
  let byteArray = [];
  let start = false;

  window.startLoadPdf = async () => {
    byteArray = [];
    start = true;
  };
  window.loadingPdf = async (base64) => {
    try {
      if (start) {
        const originData = await atob(base64);
        byteArray.push(originData);
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  };
  window.endLoadPdf = async (_readOnly) => {
    const arrayBuffer = new ArrayBuffer(
      byteArray.reduce((acc, x) => acc + x.length, 0)
    );
    const dataView = new DataView(arrayBuffer);
    let offset = 0;
    for (let i = 0; i < byteArray.length; i++) {
      for (let j = 0; j < byteArray[i].length; j++) {
        dataView.setUint8(offset, byteArray[i][j].charCodeAt(0));
        offset++;
      }
    }
    arrayBuffers = arrayBuffer;
    readOnly = _readOnly;
    byteArray = [];
    start = false;
  };
  window.loadFile = async (pdf, _readOnly) => {
    if (end) {
      arrayBuffers = new Uint16Array(byteArray).buffer;
      readOnly = _readOnly;
    }
  };
</script>

<svelte:head>
  <link
    href="https://fonts.googleapis.com/css?family=Nanum+Gothic"
    rel="stylesheet"
  />
  <link
    href="//fonts.googleapis.com/css?family=Roboto:400,700"
    rel="stylesheet"
  />
</svelte:head>
<span class="error">{errorMsg}</span>

{#if subDividing && readOnly == false}
  <div class="cc-subDivide-doc">
    <div class="alert-divider"></div>
    <div class="alert-title">
      <span class="msg-text"
        >50페이지가 넘었습니다. 페이지를 분할하시면 보다 빠르게 펜차트를 사용 할
        수 있습니다.</span
      >
      <Button
        size="sm"
        outline
        color="primary"
        on:click={() => psPDFKit.funcSubDividing()}>분할</Button
      >
    </div>
  </div>
{/if}
{#if arrayBuffers}
  <PSPDFKitComponent
    bind:this={psPDFKit}
    {arrayBuffers}
    {customFonts}
    bind:readOnly
    bind:errorMsg
    bind:subDividing
  />
{/if}

<style>
  .cc-subDivide-doc {
    border: 1px solid;
  }
  .cc-subDivide-doc .alert-divider {
    height: 5px;
    background: #fc0;
  }
  .cc-subDivide-doc .alert-title {
    padding: 2px 20px;
    display: flex;
  }
  .cc-subDivide-doc .alert-title .msg-text {
    flex: 1;
    margin: auto;
  }
  body {
    font-family: "Noto Sans Korean", sans-serif !important;
  }
  .load-spinner {
    position: fixed;
    z-index: 6000;
    top: 0;
    left: 0;
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
    background-color: rgba(22, 22, 22, 0.5);
  }
</style>
